


















































































import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  reactive,
  ref,
  watch,
  getCurrentInstance,
} from '@vue/composition-api';
import _ from 'lodash';
import InviteQrcode from '@/renderer/components/Qrcode/components/InviteQrcode.vue';
import i18n, { i18n_t } from '@/locales/i18n';
import inviteMembersHandler from '@/renderer/views/desktop/ManageConsole/UserManagement/innerUser/compositions/inviteMemberHandler';
import { RoleMap } from '@/renderer/scripts/utils/ConstantConfig';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { httpUrl } from '@/renderer/scripts/http';
import smh from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';
import user from '@/renderer/scripts/utils/user';
import ipc from '@/renderer/scripts/utils/ipc';
import { IS_BROWSER } from '@/common/constant/platform';

/** 行业信息存量数据兼容处理 */
/* i18n-ignore*/
const BUSINESS_MAP: { [key: string]: string } = {
  education: 'education',
  教育行业: 'education',
  finance: 'finance',
  金融行业: 'finance',
  retail: 'retail',
  零售行业: 'retail',
  medical: 'medical',
  医疗行业: 'medical',
};

// 默认行业数据
const defaultTradeItems = [
  {
    title: i18n_t('教育行业'),
    subTitle: i18n_t('知识沉淀管理，分享更高效'),
    logans: [i18n_t('作业收集'), i18n_t('海量教学资料库'), i18n_t('内容安全管理')],
    type: 'education',
  },
  {
    title: i18n_t('金融行业'),
    subTitle: i18n_t('掌控信息安全的企业生命线'),
    logans: [i18n_t('文件安全管理'), i18n_t('员工安全管理'), i18n_t('高效办公协作')],
    type: 'finance',
  },
  {
    title: i18n_t('零售行业'),
    subTitle: i18n_t('跨地极速传输，上下游无间协作'),
    logans: [i18n_t('生产资料流转'), i18n_t('销售协作分享'), i18n_t('员工安全管控')],
    type: 'retail',
  },
  {
    title: i18n_t('医疗行业'),
    subTitle: i18n_t('统一归档，数据信息化管理'),
    logans: [i18n_t('资料影像库'), i18n_t('报告分享汇报'), i18n_t('文件签字审批')],
    type: 'medical',
  },
];

// 自定义行业数据
const customTradeItem = {
  title: i18n_t('腾讯云企业网盘'),
  subTitle: i18n_t('一站式企业文件管理协作平台'),
  logans: [i18n_t('文件安全管理'), i18n_t('高效办公协作'), i18n_t('在线签合同')],
  type: 'custom',
};
export default defineComponent({
  name: 'InviteMember',
  components: {
    InviteQrcode,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const store = context.root.$store;
    const innerShow = ref(false);
    const { inviteUrlInfo, methods: inviteMemberMethods } = inviteMembersHandler();
    const isSaved = ref(false);
    const loading = ref(true);
    const showHeader = ref(true);
    const showCreateTitle = ref(true);
    const showGuidePopup = ref(false); // 是否触发引导气泡事件，默认不触发，只有新入流程时触发
    const hasTradeInfo = ref(true);
    const videoItems = computed(() => {
      const wechatItem = [
        {
          icon: 'wechat',
          videoTitle: i18n_t('通过关联组织架构'),
          videoInfo: i18n_t('支持企业微信、SSO、Open LDAP等'),
          step: 'two',
        },
      ];

      const phoneItem = [
        {
          icon: 'phone',
          videoTitle: i18n_t('通过手机号批量添加成员'),
          videoInfo: i18n_t('填写模版，一键批量导入成员'),
          step: 'one',
        },
      ];
      return store.getters.isPrivate ? phoneItem : [...wechatItem, ...phoneItem];
    });
    const tradeItem = reactive(_.cloneDeep(customTradeItem));
    const methods = {
      open(options?: { header: boolean; title: boolean; showGuide: boolean }) {
        const {
          header,
          title,
          showGuidePopup: showGuide,
        } = Object.assign(
          {
            header: true,
            title: true,
            showGuidePopup: false,
          },
          options,
        );
        showHeader.value = header;
        showCreateTitle.value = title;
        innerShow.value = true;
        showGuidePopup.value = showGuide;
      },
      close() {
        innerShow.value = false;
      },
      async init() {
        try {
          loading.value = true;
          const { userRole } = user.getUserInfo();
          // 1. 判断是否是超管
          if (userRole === RoleMap.SuperAdmin) {
            const { data } = await smh.userAPI.getSurvey({
              type: 'create-org-info',
            });
            // 会议渠道免费注册时不需要留资行业方案为空,不需要展示解决方案
            if (Array.isArray(data) && data.length === 0) {
              hasTradeInfo.value = false;
            } else if (Array.isArray(data) && data.length === 1) {
              const { business } = data[0].data;
              if (business) {
                const defaultTradeItem = defaultTradeItems.filter(item => item.type === BUSINESS_MAP[business]);
                customTradeItem.title = business;
                if (defaultTradeItem.length) {
                  Object.assign(tradeItem, defaultTradeItem[0]);
                } else {
                  Object.assign(tradeItem, customTradeItem);
                }
              }
            }
          }
        } catch (e: MsgError) {
          tips.error(e);
        } finally {
          loading.value = false;
        }
      },
      clickHandler(step: 'one' | 'two') {
        const tjdMap = {
          one: 'step_three_member_list',
          two: 'step_three_idaas',
        };
        reporter.report('manager_new_guide_success', {
          success_count_type: tjdMap[step],
        });
        const videoNum = step === 'one' ? '001' : '002';
        if (IS_BROWSER) {
          dispatchRouter(
            `${httpUrl.staticCDNUrl}/tools/videos/guide_${videoNum}.mp4`,
            'newWindow',
            'height=500,width=700,top=200,left=300',
          );
        } else {
          dispatchRouter(`${httpUrl.staticCDNUrl}/tools/videos/guide_${videoNum}.mp4`);
        }
      },
      closeInvite() {
        innerShow.value = false;
        if (showGuidePopup.value) {
          ipc.emit(ipc.RENDERER_EVENTS_MAP.SHOW_GUIDE_POPUP);
        }
        ipc.emit(ipc.RENDERER_EVENTS_MAP.STOP_GUIDE);
      },
      async gotoMenu(step: 'one' | 'two') {
        methods.closeInvite();
        if (step === 'one') {
          const canAddUser = await store.dispatch('checkUserCount');
          if (!canAddUser) return;
          dispatchRouter({
            name: 'userManagement',
            params: {
              action: 'openImport',
            },
          });
          reporter.report('manager_new_guide', {
            configure_members: 'phone',
          });
        } else {
          dispatchRouter({
            name: 'accountAssociation',
          });
          reporter.report('manager_new_guide', {
            configure_members: 'organizational_structure',
          });
        }
      },
      saved(action: string) {
        isSaved.value = true;
        if (action === 'copy') {
          reporter.report('manager_new_guide', {
            configure_members: 'copy_link',
          });
        } else if (action === 'download') {
          reporter.report('manager_new_guide', {
            configure_members: 'qrcode',
          });
        }
      },
    };
    watch(innerShow, val => {
      if (val && !store.getters.isPrivate) {
        inviteMemberMethods.initData(true);
        methods.init();
      }
    });
    onMounted(() => {
      ipc.on(ipc.RENDERER_EVENTS_MAP.SHOW_INVITE_DIALOG, methods.open);
    });
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.SHOW_INVITE_DIALOG, methods.open);
    });
    return {
      showCreateTitle,
      showHeader,
      innerShow,
      videoItems,
      tradeItem,
      inviteUrlInfo,
      hasTradeInfo,
      ...methods,
      isSaved,
      loading,
      inviteMemberMethods,
    };
  },
});
